(() => {
  const configNode = document.querySelector('[data-gq-price-config]');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: 'EUR' }).format(value / 100);
  let catalog, loading, failed = false;
  const priceSelector = '[data-gq-catalog-price], [data-gq-product-schema]';
  const hasPrices = root => root.matches?.(priceSelector) || root.querySelector(priceSelector);
  const findEntry = ({ productId, handle, family, kind }) => {
    const exact = catalog?.products?.find(p => p.productId === productId) || catalog?.supports?.find(s => s.productId === productId || s.handle === handle);
    if (exact) return exact;
    const candidates = family && kind ? catalog?.supports?.filter(s => s.family === family && s.role === kind) || [] : [];
    return candidates.length === 1 ? candidates[0] : null;
  };
  const validPrice = entry => entry && config.showFrom && (!config.currency || config.currency === 'EUR') && Number.isSafeInteger(entry.cents) && entry.cents > 0;
  function applySchemas(root) {
    const schemas = [...(root.matches?.('[data-gq-product-schema]') ? [root] : []), ...root.querySelectorAll('[data-gq-product-schema]')];
    for (const node of schemas) {
      const entry = findEntry(node.dataset);
      let data;
      try { data = JSON.parse(node.textContent); } catch { continue; }
      delete data.offers;
      if (node.dataset.handle !== 'porte-cles-prenom-personnalise-3d' && validPrice(entry)) data.offers = {
        '@type': 'Offer', price: (entry.cents / 100).toFixed(2), priceCurrency: 'EUR', url: data.url,
        seller: { '@type': 'Organization', name: data.brand.name }
      };
      node.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
    }
  }
  function apply(root = document) {
    const nodes = [...(root.matches?.('[data-gq-catalog-price]') ? [root] : []), ...root.querySelectorAll('[data-gq-catalog-price]')];
    for (const node of nodes) {
      if (node.dataset.resolved || (!catalog && !failed)) continue;
      const entry = findEntry(node.dataset), personalized = !!entry || node.dataset.personalized === 'true';
      const value = node.querySelector('[data-gq-price-value]'), note = node.querySelector('[data-gq-price-note]');
      if (!value || !note) continue;
      if (validPrice(entry)) { value.textContent = config.from + ' ' + money(entry.cents); note.textContent = node.dataset.handle === 'enseigne-led-personnalisee' && document.querySelector('[data-lf-led-intro]') ? note.textContent : config.finalNote; }
      else if (personalized) { value.textContent = config.quote; note.textContent = node.dataset.handle === 'enseigne-led-personnalisee' && document.querySelector('[data-lf-led-intro]') ? note.textContent : config.finalNote; }
      else {
        const nativeCents = Number(node.dataset.nativeCents);
        const template = node.querySelector('template');
        value.textContent = (!config.currency || config.currency === 'EUR') && Number.isSafeInteger(nativeCents) && node.dataset.nativeCents !== undefined
          ? (node.dataset.nativeVaries === 'true' ? config.from + ' ' : '') + money(nativeCents)
          : template?.content.textContent || config.pending;
        note.textContent = config.options;
      }
      const card = node.closest('.lf-shop-card');
      if (card && personalized) {
        card.classList.add('lf-shop-card--personalized');
        const label = card.querySelector('[data-gq-cta-label]'); if (label) label.textContent = config.personalize;
        const badge = card.querySelector('.lf-shop-card__badge'); if (badge) badge.hidden = true;
      }
      const priceBlock = node.closest('[data-gq-native-price-host]');
      if (priceBlock) {
        const native = priceBlock.querySelector('[data-gq-native-price-content]');
        if (native) native.hidden = personalized;
        node.hidden = !personalized;
      }
      node.dataset.personalized = String(personalized); node.dataset.resolved = 'true';
    }
    applySchemas(root);
  }
  async function load() {
    for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const url = new URL('/api/storefront/prices', config.origin);
      if (url.protocol !== 'https:') throw Error();
      const response = await fetch(url, { signal: AbortSignal.timeout(12000), credentials: 'omit' });
      if (!response.ok) throw Error();
      const data = await response.json();
      if (data.currency !== 'EUR' || !Array.isArray(data.products) || !Array.isArray(data.supports)) throw Error();
      catalog = data;
      failed = false;
      return;
    } catch {
      if (attempt === 2) { failed = true; return; }
      await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)));
    }
    }
  }
  async function refresh(root = document) {
    if (!hasPrices(root)) return;
    loading ||= load();
    await loading;
    if (root.isConnected !== false) apply(root);
  }
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (hasPrices(node))))) return;
    queued = true; queueMicrotask(() => { queued = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true });
  refresh();
})();

